import { formatAs } from 'cademy-shared-web';

export const renderPriceRange = (offers = []) => {
    if (!offers || !offers.length) return null;

    if (offers.length === 1) {
        return formatAs.priceShowFree(offers[0].price);
    }

    if (offers.length > 1) {
        const sortedOffers = [...offers].sort((a, b) => a.price - b.price);
        return `${formatAs.priceShowFree(sortedOffers[0].price)} - ${formatAs.priceShowFree(sortedOffers[sortedOffers.length - 1].price)}`;
    }

    return null;
};
